/**
 * Campaign API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const campaignApi = {
    // 캠페인 정보 불러오기(Get campaign information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest_get_campaign_by_location
    campaign(params) {
        return httpService.get(`/campaign`, params)
    },
}

// export const 
export default campaignApi